export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7506.f98d1276.jpg";